import { useLazyQuery } from '@apollo/client';

import { totalRowsQuery } from './gql';
import { IQueryResult, ITotalPendingReturnProductVariables } from './interfaces';

export const useTotalPendingReturnProductsGql = () => {
  const [runTotalPendingReturnProductsGql, { loading, data, error }] = useLazyQuery<IQueryResult, ITotalPendingReturnProductVariables>(
    totalRowsQuery,
    {
      context: {
        headers: {
          userFunctionKey: '3416a75f4cea9109507cacd8e2f2aefc'
        }
      },
      fetchPolicy: 'network-only'
    }
  );

  return {
    runTotalPendingReturnProductsGql,
    loadingTotalPendingReturnProducts: loading,
    dataTotalPendingReturnProducts: data?.pendingReturnProducts[0] || [],
    errorTotalPendingReturnProducts: error
  };
};
